export default "__VITE_ASSET__Bk0fuuqs__"